export default {"src":"/_next/static/media/add_folder.d4cd5065.svg","height":48,"width":50,"blurWidth":0,"blurHeight":0};